import { defineStore } from 'pinia';
import { ref } from 'vue';

export type AiPageContentEditPreview = {
  fieldPath: string;
  fieldLabel: string;
  original: string;
  revised: string;
  messageId: string;
  /** 表格等场景下唯一定位单元格，避免同文重复项全部被预览/采纳 */
  cellKey?: string;
  /** 文档评审等：引用时的段落序号（1-based） */
  paragraphIndex?: number;
  /** 文档评审等：段落标签或 Excel 单元格坐标 */
  paragraphLabel?: string;
  /** 用户引用时的原文，用于定位回退 */
  quoted?: string;
};

export type AiPageContentLocateQuote = {
  quoted: string;
  paragraphIndex?: number;
  paragraphLabel?: string;
  /** 每次定位递增，确保重复点击同一引用也会刷新高亮 */
  tick: number;
};

/** 页面正文内联展示 AI 改写 diff（淡蓝原文 + 红色改写） */
export const useAiPageContentEditPreviewStore = defineStore('aiPageContentEditPreview', () => {
  const activePreview = ref<AiPageContentEditPreview | null>(null);
  const pendingLocateQuote = ref<AiPageContentLocateQuote | null>(null);

  function setPreview(preview: AiPageContentEditPreview) {
    activePreview.value = preview;
  }

  function clearPreview() {
    activePreview.value = null;
  }

  function requestLocateQuote(args: Omit<AiPageContentLocateQuote, 'tick'>) {
    const quoted = String(args.quoted ?? '').trim();
    if (!quoted) return;
    pendingLocateQuote.value = {
      quoted,
      paragraphIndex: args.paragraphIndex,
      paragraphLabel: args.paragraphLabel,
      tick: Date.now(),
    };
  }

  function clearLocateQuote() {
    pendingLocateQuote.value = null;
  }

  return {
    activePreview,
    pendingLocateQuote,
    setPreview,
    clearPreview,
    requestLocateQuote,
    clearLocateQuote,
  };
});
